import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreStatusIndicator } from "@slhuicore/status-indicator";

import { style } from "./assets/status-indicator.generated-style";

/**
 * An indicator highlights a page element and informs the user of something that needs the user’s attention.
 * The indicator will denote that there has been a change to a particular item.
 * @CustomElement slh-status-indicator
 *
 * @cssprop --slh-default-font-family - Font family.
 * @cssprop --slh-base-xs-font-size - Font size.
 * @cssprop --slh-base-xxs-line-height - Line height.
 * @cssprop --slh-color-success - Success state status indicator color.
 * @cssprop --slh-color-error - Error state status indicator color.
 * @cssprop --slh-color-warning - Warning state status indicator color.
 * @cssprop --slh-color-info - Info state status indicator color.
 * @cssprop --slh-color-neutral-shade-40 - Default status indicator color.
 * @cssprop --slh-color-neutral-shade-80 - Font Color.
 *
 * @slot default - Status indicator label.
 */
@customElement("slh-status-indicator")
export default class SlhStatusIndicator extends SlhCoreStatusIndicator(
  LitElement
) {
  static styles = style;
}
